import { useCallback, useState } from 'react';
import Controls from 'features/controls';
import { Button } from 'antd';
import { AddEmployeeModal } from 'features/controls/addAdmin';
import SecurityModal from 'features/controls/security/SecurityModal';
import { useAppSelector } from 'app/store';
import { Permissions } from 'widgets/sidebar/menu/types';
import { RolesUser } from 'shared/enums';
import { useTitle } from '../helpers';
import styles from './index.module.scss';

const isHrDirector = (role: RolesUser) => {
  return role === RolesUser.HRDirector;
};

/**
 * @page Controls page
 */
const ControlsPage = () => {
  const [isAddAdminModalOpen, setIsAddAdminModalOpen] = useState(false);
  const [isSecurityModalOpen, setIsSecurityModalOpen] = useState(false);
  const me = useAppSelector(state => state.entities.viewer.me);
  useTitle('Управление');

  const toggleAddAdminModal = () => {
    setIsAddAdminModalOpen(isModalOpen => !isModalOpen);
  };

  const toggleSecurityModal = () => {
    setIsSecurityModalOpen(isModalOpen => !isModalOpen);
  };

  const checkPermissionsForSettings = useCallback(() => {
    const isHavePermissions = me.permissions.find(elem => elem === Permissions['hr.settings.access']);
    return !!isHavePermissions;
  }, [me]);

  return (
    <>
      <div>
        <div className={styles['control-title-block']}>
          <h3>Управление</h3>
          <div className={styles.buttons}>
            {checkPermissionsForSettings() ? <Button onClick={toggleSecurityModal}>Настройки</Button> : null}

            {me.role && isHrDirector(me.role as RolesUser) && (
              <Button type="primary" onClick={toggleAddAdminModal}>
                Добавить администратора
              </Button>
            )}
          </div>
        </div>
        <Controls />
      </div>
      <AddEmployeeModal isModalOpen={isAddAdminModalOpen} setIsModalOpen={setIsAddAdminModalOpen}></AddEmployeeModal>
      <SecurityModal
        isModalOpen={isSecurityModalOpen}
        setIsModalOpen={val => setIsSecurityModalOpen(val)}
      ></SecurityModal>
    </>
  );
};

export default ControlsPage;
